/** Maximum number of accommodations that can be booked in a single booking. */
export const MAX_BOOKABLE_ROOMS = 9;
